export const projects = {
  pageTitle: 'إنجازاتنا',
  pageSubtitle: 'اكتشف مشاريع التجديد والبناء التي أنجزناها في بروكسل ومحيطها. كل مشروع يعكس التزامنا بالجودة ورضا العملاء',
  
  // Filters
  filterAll: 'جميع المشاريع',
  filterApartment: 'شقق',
  filterHouse: 'منازل',
  filterBathroom: 'حمامات',
  filterKitchen: 'مطابخ',
  
  // Loading & Empty States
  loading: 'جاري تحميل المشاريع...',
  noProjects: 'لم يتم العثور على مشاريع',
  noProjectsDesc: 'ستظهر المشاريع هنا قريبًا',
  
  // Stats
  projectsCompleted: 'مشروع منجز',
  yearsExperience: 'سنة من الخبرة',
  satisfiedClients: 'عملاء راضون',
  projectsDelivered: 'مشاريع مسلمة',
  
  // CTA
  ctaTitle: 'هل سيكون مشروعك التالي؟',
  ctaText: 'اتصل بنا لمناقشة مشروع التجديد الخاص بك. سنكون سعداء بمرافقتك',
  ctaButton: 'اطلب عرض سعر مجاني'
};